export const locale = {
    Loading: {
        Waiting : "لطفا صبر کنید",
        Description : "چند لحظه تا چند دقیقه صبر کنید"
    },
    Questions:{
        Yes : "بله",
        No : "خیر"
    },
    Success:{
        Title : "موفقیت آمیز",
        defaultActionText : "فهمیدم"
    },
    Info:{
        Title : "اطلاع رسانی",
        defaultActionText : "فهمیدم"
    },
    Warning:{
        Title : "توجه",
        defaultActionText : "فهمیدم"
    },
    Error:{
        Title : "خطا",
        defaultActionText : "فهمیدم"
    },
    Wallet:{
        Title : "موجوی ناکافی",
        defaultActionText : "فهمیدم"
    },
    ConnectionLost :{
        Title : "دسترسی اینترنت وجود ندارد",
        Button : "تلاش مجدد"
    }
}